import React, { ReactNode } from "react";

import HomeHeader from "../HomeHeader";
import HomeFooter from "../HomeFooter";

import style from "./HomeLayout.module.scss";

type Props = {
  children: ReactNode;
};

export default function HomeLayout(props: Props) {
  const { children } = props;

  return (
    <div className={style.lending}>
      <HomeHeader />

      <main>{children}</main>

      <HomeFooter />
    </div>
  );
}
